<template>
  <el-dialog
    :close-on-click-modal="!loading"
    :show-close="false"
    :visible.sync="isShow"
    :width="device.desktop ? '330px' : '90%'"
    append-to-body
    custom-class="report-dialog"
  >
    <template #title>
      <el-divider><span class="h-title">举报</span></el-divider>
    </template>
    <div class="list">
      <template >
        <div v-for="(item, index) in list" :key="item.id" class="item" @click="activeIndex = index">
          <span>{{ item.reason }}</span>
          <div :class="['radio', index == activeIndex ? 'active' : '']">
            <div></div>
          </div>
        </div>
      </template>
    </div>
    <input
      v-if="activeIndex == 3"
      v-model="otherReason"
      class="other-reason mT20"
      maxlength="50"
      placeholder="其他理由"
      type="text"
    />

    <el-button :loading="loading" class="W100 mT20" size="default" type="primary" @click="onOk">提交 </el-button>
  </el-dialog>
</template>

<script>
import { apiReport } from "@/api/reportApi";

export default {
  name: "reportDialog",
  mixins: [],
  props: {},
  model: {},
  components: {},
  data() {
    return {
      isShow: false,
      activeIndex: 0,
      list: [
        {
          reason: "有敏感反动内容",
          id: 1
        },
        {
          reason: "低俗色情",
          id: 2
        },
        {
          reason: "垃圾广告",
          id: 3
        },
        {
          reason: "其他违规理由",
          id: 4
        }
      ],
      otherReason: "",
      // 来源id
      id: 0,
      // 1=>文章，2=>评论
      type: 1,
      loading: false
    };
  },
  computed: {},
  methods: {
    init() {
      this.activeIndex = 0;
      this.otherReason = "";
    },
    onOk() {
      let { activeIndex, list, otherReason } = this;
      let params = {
        origin_id: this.id,
        origin_type: this.type,
        reason: list[activeIndex].reason + (activeIndex == 3 ? "-" + otherReason : "")
      };
      if (activeIndex == 3 && !otherReason) {
        this.$message("请填写其他原因");
        return;
      }
      this.loading = true;
      apiReport(params)
        .then(res => {
          this.isShow = false;
        })
        .finally(_ => {
          this.loading = false;
        });
    }
  },
  watch: {
    isShow: "init"
  },
  created() {},
  mounted() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="less" scoped>
/deep/ .report-dialog {
  .el-dialog__header {
    font-size: 16px;

    .el-divider {
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .h-title {
      font-size: 16px;
    }
  }
}

.list {
  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    cursor: pointer;

    .radio {
      width: 16px;
      height: 16px;
      border: 1px solid @gray;
      border-radius: 14px;
      color: #626262;
      font-size: 14px;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: 0.3s;

      div {
        width: 0;
        height: 0;
        border-radius: 10px;
        background: @text-basic;
      }

      &.active {
        div {
          width: 8px;
          height: 8px;
        }
      }
    }
  }
}

.other-reason {
  height: 44px;
  width: 100%;
  background: #f5f5f5;
  border-radius: 4px;
  padding: 0 10px;
  font-size: 14px;
  color: @text-basic;
  border: none;
}
</style>
